import { render } from "./RolePermissionGrid.vue?vue&type=template&id=646e10c3"
import script from "./RolePermissionGrid.vue?vue&type=script&lang=js"
export * from "./RolePermissionGrid.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__